import { Column } from "react-table";

export type InstitutionAdminListData = {
  title: string;
  first_name: string;
  last_name: string;
  email: string;
  institution: string;
  actions: React.ReactNode;
};

export const columns: Column<InstitutionAdminListData>[] = [
  {
    Header: "Title",
    accessor: "title",
  },
  {
    Header: "First Name",
    accessor: "first_name",
  },
  {
    Header: "Last Name",
    accessor: "last_name",
  },
  {
    Header: "E-mail address",
    accessor: "email",
  },
  {
    Header: "Institution",
    accessor: "institution",
  },
  {
    accessor: "actions",
  },
];
